import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import {
  ApplicationState,
  getShowCreateMailboxLink,
} from '../../store/reducers';
import { Observable } from 'rxjs';

@Injectable()
export class CreateMailboxGuard implements CanActivate {
  constructor(
    private store: Store<ApplicationState>,
    private router: Router,
  ) {}

  canActivate(): Observable<boolean> {
    return new Observable((observer) => {
      this.store
        .select(getShowCreateMailboxLink)
        .subscribe((addMailboxLink) => {
          if (addMailboxLink !== undefined) {
            observer.next(true);
            observer.complete();
            if (!addMailboxLink) {
              this.router.navigate(['/details/Mail/_']);
            }
          }
        });
    });
  }
}
